import type React from 'react';
import { useEffect } from 'react';
import { AdMob } from '@capacitor-community/admob';
import { Capacitor } from '@capacitor/core';
import { adAndroidInterstitial, adIosInterstitial } from 'helpers/InitAdmob';

const InterstitialAd: React.FC = () => {
  useEffect(() => {
    const setupAd = async () => {
      try {
        await AdMob.prepareInterstitial({
          adId: Capacitor.getPlatform() === 'ios' ? adIosInterstitial : adAndroidInterstitial,
          isTesting: false,
        });
      } catch (error) {
        console.error('Error preparing interstitial ad:', error);
      }
    };

    try {
      setupAd();
    } catch (e) {
      console.warn(e);
    }

    return () => {
      try {
        AdMob.removeBanner();
      } catch (e) {
        console.warn(e);
      }
    };
  }, []);

  return null;
};

export default InterstitialAd;
